// src/api/anagrafiche/clientiApi.ts

import { handleResponse, handleError, headerset } from "../../apiUtils";
import { Cliente, FiltriClienti } from "components/anagrafiche/clienti/clientiSlice";

const baseUrl = (cliente_id?: number | null) => {
    let url: string = process.env.API_URL + "/api/anagrafiche/clienti/";

    if (cliente_id) {
        url += cliente_id + "/";
    }

    return url;
};

const buildQueryString = (filtri: FiltriClienti): string => {
    const params = new URLSearchParams();

    // Filtro ricerca
    if (filtri.search) {
        params.append('search', filtri.search);
    }

    // Paginazione
    if (filtri.page) {
        params.append('page', filtri.page.toString());
    }
    if (filtri.numero_record) {
        params.append('numero_record', filtri.numero_record.toString());
    }

    return params.toString();
};

export function fetchClienti(filtri: FiltriClienti = {}) {
    let url = baseUrl();
    const queryString = buildQueryString(filtri);
    if (queryString) {
        url += `?${queryString}`;
    }

    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

export function getCliente(cliente_id: number) {
    const url = baseUrl(cliente_id);
    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}

export function saveCliente(clienteToSave: Cliente) {
    // Prepara i dati per l'invio
    const clienteData = {
        ...clienteToSave,
    };


    return fetch(baseUrl(clienteToSave.id), {
        method: clienteToSave.id ? "PUT" : "POST", // PUT to update when id already exists
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
        body: JSON.stringify(clienteData),
    })
        .then(handleResponse)
        .catch(handleError);
}

export function deleteCliente(clienteToDelete: Cliente) {
    return fetch(baseUrl(clienteToDelete.id), {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}